import { render, staticRenderFns } from "./AccountUpgrade.vue?vue&type=template&id=67fe93e0"
import script from "./AccountUpgrade.vue?vue&type=script&lang=js"
export * from "./AccountUpgrade.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports